var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLowVoc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "49px",
    viewBox: "0 0 48 49",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Low VOC") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Website-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Low-VOC",
    transform: "translate(1.000000, 1.338422)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#000000",
    strokeWidth: 1.5,
    cx: 23,
    cy: 23,
    r: 23
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(8.500000, 12.000000)",
    fill: "#000000",
    fontFamily: "Archia-Medium, Archia",
    fontSize: 12,
    fontWeight: 400,
    "line-spacing": 12
  }, /*#__PURE__*/React.createElement("text", {
    id: "Low"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 11
  }, "LOW")), /*#__PURE__*/React.createElement("text", {
    id: "VOC"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 23
  }, "VOC")))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowVoc);
export default __webpack_public_path__ + "static/media/lowVoc.aade368e242b3929b105fd4e686e4ead.svg";
export { ForwardRef as ReactComponent };